import { Api } from './axios-config';

export interface ICashFlowItem {
  id: number;
  type: string;
  description: string;
  amount: number;
  category?: string;
  date: Date;
  createdByName: string;
}

export interface ICashFlowSummary {
  totalAppointments: number;
  totalManualIn: number;
  totalManualOut: number;
  netCashFlow: number;
}

const getAll = async (
  businessId: number,
  startDate?: Date,
  endDate?: Date
): Promise<ICashFlowItem[]> => {
  try {
    const params = new URLSearchParams();
    params.append('businessId', businessId.toString());
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const { data } = await Api.get<ICashFlowItem[]>(`/cashflow?${params.toString()}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getSummary = async (
  businessId: number,
  startDate?: Date,
  endDate?: Date
): Promise<ICashFlowSummary> => {
  try {
    const params = new URLSearchParams();
    params.append('businessId', businessId.toString());
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const { data } = await Api.get<ICashFlowSummary>(`/cashflow/summary?${params.toString()}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const cashFlowService = {
  getAll,
  getSummary,
};
